import { useState } from 'react';
import { Box, Button } from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';

const ProfileAlphaToggle = ({ children, enabled }) => {
  const [profileAlphaEnabled, setProfileAlphaEnabled] = useState(true);

  const toggleProfileAlpha = () => {
    setProfileAlphaEnabled((currentState) => !currentState);
  };

  return (
    <>
      {children(profileAlphaEnabled)}
      {enabled ? (
        <Box position="fixed" top="3xsmall" left="50%" zIndex="1000">
          <Button baseColor="green" variant="filled" onClick={toggleProfileAlpha}>
            Switch profile
          </Button>
        </Box>
      ) : null}
    </>
  );
};

ProfileAlphaToggle.propTypes = {
  children: PropTypes.node,
  enabled: PropTypes.bool,
};

export default ProfileAlphaToggle;
